import { v4 as uuidv4 } from 'uuid';
import { EMPLOYER_MATCH_OPTIONS, EMPLOYER_LIMIT_OPTIONS } from './EmployerMatchConstants';

export const createTier = (match, limit) => ({
  Id: uuidv4(),
  Match: match,
  Limit: limit,
});

export const mapLimit = (limitType, employerLimit) => {
  switch (limitType) {
    case EMPLOYER_LIMIT_OPTIONS.UP_3:
      return '3.00';
    case EMPLOYER_LIMIT_OPTIONS.UP_6:
      return '6.00';
    case EMPLOYER_LIMIT_OPTIONS.OTHER:
      return employerLimit;
    default:
      return '';
  }
};

export const mapEmployerMatchData = (account) => {
  const {
    EmployerMatchType,
    EmployerLimitType,
    EmployerLimit,
    EmployerMatchPercent,
  } = account;
  const limit = mapLimit(EmployerLimitType, EmployerLimit);
  switch (EmployerMatchType) {
    case EMPLOYER_MATCH_OPTIONS.MATCH_50:
      return [createTier('50', limit)];
    case EMPLOYER_MATCH_OPTIONS.MATCH_100:
      return [createTier('100', limit)];
    case EMPLOYER_MATCH_OPTIONS.OTHER_MATCH:
      return [createTier(EmployerMatchPercent, limit)];
    case EMPLOYER_MATCH_OPTIONS.SAFE_HARBOR_1:
      return [createTier('100', '3')];
    case EMPLOYER_MATCH_OPTIONS.SAFE_HARBOR_2:
      return [
        createTier('100', '3'),
        createTier('50', '2'),
      ];
    case EMPLOYER_MATCH_OPTIONS.PERCENT_COMPENSATION:
      return [createTier(EmployerMatchPercent, null)];
    default:
      return null;
  }
};
